import React from "react";

import { Link } from "react-router-dom";

import {
  Mail,
  MapPin,
  Facebook,
  Instagram,
  Twitter,
  Linkedin,
} from "react-feather";

import Logo from "../logo";

import * as Styles from "./styles";

const AppFooter = () => {
  return (
    <Styles.Container>
      <Styles.MainFooter>
        <div className="container">
          <Styles.RowHolder>
            <Styles.BrandColumn>
              <Styles.LogoChip>
                <Logo />
              </Styles.LogoChip>
              <Styles.BrandText>
                We provide best retrofitting and structural strengthening
                services for residential, commercial, and industrial projects.
              </Styles.BrandText>
              <Styles.SocialHolder>
                <a
                  href="https://www.facebook.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="CapaStrength on Facebook"
                >
                  <Facebook aria-hidden="true" />
                </a>
                <a
                  href="https://www.instagram.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="CapaStrength on Instagram"
                >
                  <Instagram aria-hidden="true" />
                </a>
                <a
                  href="https://www.twitter.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="CapaStrength on Twitter"
                >
                  <Twitter aria-hidden="true" />
                </a>
                <a
                  href="https://www.linkedin.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="CapaStrength on LinkedIn"
                >
                  <Linkedin aria-hidden="true" />
                </a>
              </Styles.SocialHolder>
            </Styles.BrandColumn>

            <nav aria-label="Footer navigation">
              <Styles.ColumnTitle>Company</Styles.ColumnTitle>
              <Styles.MenuListHolder>
                <Styles.MenuListItem>
                  <Link to="/">Home</Link>
                </Styles.MenuListItem>
                <Styles.MenuListItem>
                  <Link to="/about">About</Link>
                </Styles.MenuListItem>
                <Styles.MenuListItem>
                  <Link to="/projects">Projects</Link>
                </Styles.MenuListItem>
                <Styles.MenuListItem>
                  <Link to="/clients">Clients</Link>
                </Styles.MenuListItem>
                <Styles.MenuListItem>
                  <Link to="/contactus">Contact</Link>
                </Styles.MenuListItem>
                <Styles.MenuListItem>
                  <Link to="/tandc">Terms {"&"} Conditions</Link>
                </Styles.MenuListItem>
              </Styles.MenuListHolder>
            </nav>

            <Styles.ContactColumn>
              <Styles.ColumnTitle>Get in touch</Styles.ColumnTitle>
              <a href="mailto:contact@capastrength.com">
                <Styles.EmailWrapper>
                  <Mail aria-hidden="true" />
                  <Styles.TextHolder>
                    contact@capastrength.com
                  </Styles.TextHolder>
                </Styles.EmailWrapper>
              </a>
              <Styles.AddressHolder>
                <MapPin aria-hidden="true" />
                <span>
                  Office No. 201, 2nd Floor, Tarabaug CHS, Prashant Nagar, Near
                  Naupada Police Station, Thane - 400602
                </span>
              </Styles.AddressHolder>
            </Styles.ContactColumn>
          </Styles.RowHolder>
        </div>
      </Styles.MainFooter>
      <Styles.CopyrightWrapper>
        <div className="container">
          <Styles.TextHolder>
            Copyright © 2022 CapaStrength. All rights reserved.{" "}
            <Link to="/tandc">read T & C</Link>
          </Styles.TextHolder>
        </div>
      </Styles.CopyrightWrapper>
    </Styles.Container>
  );
};

export default AppFooter;
